import createModuleStorage from "app/pages/sales-intelligence/services/storage/factory";

const companyOverviewStorageProvider = createModuleStorage(localStorage, "si:company-overview");

export default companyOverviewStorageProvider;
